import { createRouter, createWebHistory } from "vue-router";
import { useUserStore } from "@/stores/userStore";

const routes = [
  {
    path: '/',
    name: 'BootstrapView',
    component: () => import('../components/BoostrapView.vue'),
  },
  {
    path: '/home',
    name: 'HomeView',
    component: () => import('../components/Home.vue'),
    meta: { requiresAuth: true, title: 'Inicio' }
  },
  {
    path: '/login',
    name: 'LoginHome',
    meta: { title: 'GRUPOMV' },
    component: () => import('../components/LoginHome.vue'),
  },
  {
    path: '/guest',
    name: 'GuestView',
    meta: { title: 'Catálogo', requiresAuth: false },
    component: () => import('../components/GuestView.vue'),
  },
  {
    path: '/ExpressMV',
    name: 'ExpressMV',
    component: () => import('../components/ExpressMV.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/appbarView',
    name: 'appbarView',
    component: () => import('../components/appbar/appbarView.vue'),
  },
  {
    path: '/user-info',
    name: 'userinfo',
    component: () => import('../components/appbar/UserInfoView.vue'),
    meta: { requiresAuth: true, title: 'Mi perfil' }
  },
  {
    path: '/metodo-pago',
    name: 'metodo',
    component: () => import('../components/PagarView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/registro',
    name: 'registro',
    component: () => import('../components/RegistroView.vue'),
  },
  {
    path: '/marcas-mvgrupo',
    name: 'marcas-peñafiel',
    component: () => import('../components/MarcasXProductoView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/datos-facturacion',
    name: 'facturacion-form',
    component: () => import('../components/menu_usuario/FacturacionView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/perfil',
    name: 'perfil',
    component: () => import('../components/menu_usuario/DatosUsuarioview.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/promo',
    name: 'promo-vista',
    component: () => import('../components/PromoView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/top-10',
    name: 'top-diez',
    component: () => import('../components/TopDiezView.vue'),
    meta: { requiresAuth: true, title: 'Top 10' }
  },
  {
    path: '/pedidos',
    name: 'historial',
    component: () => import('../components/HistorialPedidosView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/101List',
    name: '101List',
    component: () => import('../components/marcas/penafielView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/101-ElectrolitView',
    name: '101-ElectrolitView',
    component: () => import('../components/marcas/ElectrolitView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/103-redbull',
    name: '103-rb',
    component: () => import('../components/marcas/redbullView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/101-CaribeCoolerView',
    name: '101-CaribeCoolerView',
    component: () => import('../components/marcas/CaribeCoolerView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/101-JackDanielsView',
    name: '101-JackDanielsView',
    component: () => import('../components/marcas/JackDanielsView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/101-NewMix',
    name: '101-newxmix',
    component: () => import('../components/marcas/NewMixView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/101-ClamatoView',
    name: 'ClamatoView',
    component: () => import('../components/marcas/clamatoView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/101-BoonesView',
    name: '101-BoonesView',
    component: () => import('../components/marcas/BoonesView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/101-adas',
    name: '101-adas',
    component: () => import('../components/marcas/peñafiel_adasView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/101-vuala',
    name: '101-vuala',
    component: () => import('../components/marcas/VualaVistaView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/SucessView',
    name: 'SucessView',
    component: () => import('../components/SucessView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/Mapa',
    name: 'mapaview',
    component: () => import('../components/HelloWorld.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/ajuste',
    name: 'AjustesView',
    component: () => import('../components/menu_usuario/AjustesView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/100-aguafiel',
    name: 'AguaFielView',
    component: () => import('../components/categorias/AguaView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/100-EnergetizantesView',
    name: 'EnergetizantesView',
    component: () => import('../components/categorias/EnergetizantesView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/Excel-export',
    name: 'ExportExcelView',
    component: () => import('../components/Administrador/DescargarExcel.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/carrito-vue',
    name: 'carrito-vue',
    component: () => import('../components/Administrador/CarritoViewStore.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/dashboard-admin',
    name: 'dashboard-admin',
    component: () => import('../components/Administrador/DashboardView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/promo-config',
    name: 'promo-config',
    component: () => import('../components/Administrador/PromoConfigView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/Vista-stock',
    name: 'Vista-stock',
    component: () => import('../components/Administrador/VistaStock.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/buscador-pedidos',
    name: 'buscador-pedidos',
    component: () => import('../components/Administrador/BuscadorPedidos.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/bebidas-alcho',
    name: 'bebidas-alcho',
    component: () => import('../components/categorias/BebidasPrepradasView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/exce-stock-importador',
    name: 'exce-stock-importador',
    component: () => import('../components/Administrador/ImportadorExistenciaView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/aviso-privacidad',
    name: 'aviso-privacidad',
    component: () => import('../components/Administrador/AvisoVue.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/141-nissin',
    name: '141-nissin',
    component: () => import('../components/marcas/NissinView.vue'),
    meta: { requiresAuth: true }
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to, from, next) => {
  const userStore = useUserStore();

  const isInitialLoad = from.matched.length === 0;

  if (!userStore.isSessionReady && (to.path !== '/login' || isInitialLoad)) {
    try {
      await userStore.initSession();
    } catch {
      // sesión no disponible, el guard siguiente redirige al login
    }
  }

  if (to.path === '/login' && userStore.isAuthenticated) {
    return next('/home');
  }

  const publicRoutes = ['/login', '/registro', '/aviso-privacidad', '/', '/guest'];
  const requiresAuth = to.meta.requiresAuth || !publicRoutes.includes(to.path);

  if (requiresAuth && !userStore.isAuthenticated) {
    return next("/login");
  }

  next();
});

export default router;
